import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

export interface IListViewCalendarItemProperties
{
    /**
     * Kann die DataSource von dem der eigentliche Text stammt, enthalten.
     */
    dataSource?: any;

    /**
     * Anzeige Text.
     */
    text: string;

    /**
     * Die Farbe des Kalenders.
     */
    color?: string;

    /**
     * Link (react-router).
     */
    linkTo?: string;

    /**
     * Inline-Style zum überschreiben des Standard Styles.
     */
    style?: any;

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (dataSource: any, e?: MouseEvent) => void;
}

export class ListViewCalendarItem extends React.Component<IListViewCalendarItemProperties>
{
    /**
     * Führe die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { dataSource, onClick } = this.props;
        onClick && onClick(dataSource, e.nativeEvent);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <OptionalLink
                className="listview-calendar-item"
                to={this.props.linkTo}
                style={this.props.style}
                onClick={this.onClick}>
                <div
                    className="listview-calendar-item_color"
                    style={{
                        backgroundColor: this.props.color
                    }}></div>
                <span className="listview-calendar-item_text">{this.props.text}</span>
            </OptionalLink>
        );
    }
}